export const APP_VERSION = process.env.APP_VERSION as string;
export const APP_ENVIRONMENT = process.env.APP_ENVIRONMENT as string;
export const APP_URL = process.env.APP_URL as string;

export const SENTRY_DSN = process.env.SENTRY_DSN || null;
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE || null;
